import { render, staticRenderFns } from "./ModelDistribution.vue?vue&type=template&id=427955d1&"
import script from "./ModelDistribution.vue?vue&type=script&lang=js&"
export * from "./ModelDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports